import { cva as e } from "class-variance-authority";
// src/design/page-wrapper/style.ts
var t = e("w-full flex flex-col", {
	variants: {
		variant: {
			default: "px-3 py-2",
			narrow: "px-3 py-2 max-w-4xl mx-auto",
			wide: "px-6 py-4",
			centered: "px-3 py-2 items-center justify-center min-h-full"
		},
		spacing: {
			none: "gap-0",
			sm: "gap-2",
			md: "gap-4",
			lg: "gap-6",
			xl: "gap-8"
		}
	},
	defaultVariants: {
		variant: "default",
		spacing: "sm"
	}
}), n = e("w-full flex flex-col gap-1", {
	variants: { sticky: {
		true: "sticky top-0 z-sticky bg-back pb-2",
		false: ""
	} },
	defaultVariants: { sticky: !1 }
}), r = e("flex w-full flex-wrap items-start justify-between gap-x-4 gap-y-2"), i = e("flex min-w-0 flex-col gap-1"), a = e("flex max-w-full min-w-0 flex-wrap items-center gap-2"), o = e("text-lg font-semibold text-foreground"), s = e("text-sm text-muted-foreground"), c = e("w-full flex-1"), l = e("w-full mt-auto pt-4 border-t border-border"), u = () => ({
	root: t,
	header: n,
	headerRow: r,
	headerText: i,
	headerActions: a,
	title: o,
	description: s,
	content: c,
	footer: l
});
export { u as default };

//# sourceMappingURL=style.js.map